<template>
  <div class="d-flex justify-space-between align-start mb-10">
    <img alt="Logo" :src="logoPath" crossorigin="anonymous" width="56" />
    <div class="d-flex flex-column text-right">
      <div class="body3 text--semitransparent">
        {{ $t("reports.executiveSummaryReport.generatedOn") }} {{ generatedOn }}
      </div>
      <div class="body3 text--semitransparent">
        {{ $t("reports.executiveSummaryReport.version") }} {{ version }}
      </div>
    </div>
  </div>
  <v-chip
    class="px-2 py-1 mb-3"
    label
    rounded="3"
    color="indigo-faint"
    variant="flat"
    density="compact"
  >
    <span class="coro-label text-uppercase">
      {{ workplace }}
    </span>
  </v-chip>
  <div class="mb-14">
    <div class="headline5 mb-1">
      {{ $t("reports.managedServicesSummaryReport.title") }}
    </div>
    <div class="body2 mb-2">
      {{ selectedDateRange }}
    </div>
  </div>
  <div class="d-flex report-general-info__columns mb-14">
    <div class="flex-grow-1">
      <div class="d-flex flex-column">
        <div class="big-number mb-2 text-primary">
          {{ reportData.totalResolvedTickets }}
        </div>
        <div class="subtitle2 mb-2">
          {{ $t("reports.managedServicesSummaryReport.totalTicketsResolved") }}
        </div>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import type { ManagedServicesReportData } from "@/_store/reports.module";
import { computed } from "vue";
import moment from "moment";

const props = defineProps<{
  workplace: string;
  reportData: ManagedServicesReportData;
  selectedDateRange: string;
  logoPath: string;
  version: string;
}>();
const generatedOn = computed(() => moment(props.version, "YYYYMMDD_HHmmss").format("L LT"));
</script>

<style scoped lang="scss">
.report-general-info {
  &__columns {
    gap: 56px;
  }
}
</style>
